<template>
  <b-card
      style="
      margin-bottom: 10px;
      cursor:pointer;
      background-color:#222222"
      @click="handleMyAppClick"
  >
    <!-- Card body -->
    <b-row align-v="center">
      <b-col md="auto">
        <!-- Avatar -->
        <b-avatar
            :src="imgURL"
            size="4em"
            icon="pie-chart-fill"
            rounded
            variant="warning"
            style="padding: 5px"
        />
      </b-col>
      <b-col class="ml--2">
        <h4 class="mb-0" style="color: white">
          {{name }}
        </h4>
        <p class="text-sm text-muted mb-0">
        <small>{{ description ? description.substr(0, 50):'' }}</small>
        </p>
      </b-col>
      <b-col md="auto">
        <b-row class="float-right">
          <b-col>
            <b-button
                pill
                variant="primary"
                @click="handleGetClick"
            >&nbsp;
              &nbsp; Get &nbsp;
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <i> Cognition, Growth</i>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from "moment";

export default {
  name: "MyAppStore_AppCard",
  props: {
    item: { //
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    }
  },
  computed: {},
  methods:{
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    },
    handleMyAppClick(){
      this.$emit('myapp-clicked', this.item);
    },
    handleGetClick(){
      this.$emit('myapp-get-clicked', this.item);
    }
  },
  data() {
    return {
      name: this.item ? this.item.name: '',
      imgURL: this.item ? this.item.imgURL: null,
      description: this.item ? this.item.description: '',
      isCurrentlyTaking: this.item ? this.item._isCurrentlyTaking : false,
      medicationLblUrl: this.item && this.item.images && this.item.images.medicationLabel ? this.item.images.medicationLabel.imgURL: null,
      createdByImgURL: this.item && this.item._created_by ? this.item._created_by.imgURL : null,
      createdByName: this.item && this.item._created_by ? this.item._created_by.name : null,
      added_date: this.item && this.item._created_at ? this.formatDate(this.item._created_at) :null
    };
  }
};
</script>

<style lang="scss" scoped>
.photo-card {
  width: 50%;
  //   height: 357px;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  border-radius: 8px !important;
  background: #ffffff;
  position: relative;
  font-family: "Nunito", sans-serif;
  .photo-bg {
    width: 100%;
    background: rgba(184, 136, 92, 0.1);
    background-color: #ddbc9e;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background-repeat: repeat-x;
  }
  .photo-sound-btn {
    position: absolute;
    left: 0%;
    top: 85%;
    text-align: left;
    background-color: rgba(10, 9, 9, 0.7);
    color: #272f75;
    font-weight: bold;
    cursor: pointer;
    height: 55px;
    width: 135px;
    font-size: 12px;
  }
}
</style>
